import React, {useCallback, useState, useEffect, useContext} from 'react';
import {SegmentedGroup, Segmented, toast, Select, Input, Button, setOptions} from "@mobiscroll/react";
import '@mobiscroll/react/dist/css/mobiscroll.min.css';
import './styles/login.css';
import {faWatchFitness} from "@fortawesome/pro-duotone-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Empty from './utils/Empty';
import Mobile from './utils/Mobile';
import LoginHelp from "./dialogs/LoginHelp";
import {NetworkContext} from './utils/NetworkContext';

setOptions({
    theme: 'ios',
    themeVariant: 'light',
});

const StateType = () => {
    const item = window.localStorage.login;
    if (!item) {
        window.localStorage.login = 'email'
        return 'email';
    } else {
        return item;
    }
}

const StateCountry = () => {
    const item = window.localStorage.country;
    if (!item) {
        window.localStorage.country = 'us';
        return 'us';
    } else {
        return item;
    }
}

function Login({wss, token, account, locale, Navigation, dialog, Dialog, configuration, width, forgot, setForgot}) {
    const {restCall, restResponse, setRestResponse} = useContext(NetworkContext);
    const [country, setCountry] = useState(StateCountry());
    const [email, setEmail] = useState('');
    const [mobile, setMobile] = useState('');
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [next, setNext] = useState(true);
    const [type, setType] = useState(StateType());
    const [iconHover, setIconHover] = useState(null);

    const ShortenerForgot = () => {
        const message = {
            type: 'rest',
            path: 'shortener-forgot',
            action: 'update',
            data: {
                forgot: forgot,
                account: account.current
            }
        };
        restCall(message);
    }

    const ButtonLogin = () => {
        if (!password) {
            toast({message: locale.login.h, color: 'danger', display: 'bottom', duration: 3000});
        } else {
            const item = {
                account: account.current,
                password: password
            }
            if (type === 'email') {
                item.id = email;
                item.type = 'email';
            } else if (type === 'mobile') {
                item.id = mobile.replace(/[()\s-]/g, '');
                item.country = country;
                item.type = 'mobile';
            } else if (type === 'username') {
                item.id = username;
                item.type = 'username';
            }

            const message = {
                type: 'rest',
                path: 'token',
                action: 'get',
                data: item
            };
            restCall(message);
        }
    }

    const ButtonForgot = () => {
        if ((type === 'email' && !email) || (type === 'mobile' && !mobile) || (type === 'username' && !username)) {
            toast({message: locale.login.f, color: 'danger', display: 'bottom', duration: 3000});
        } else {
            const item = {
                account: account.current
            }
            if (type === 'email') {
                item.id = email;
                item.type = 'email';
            } else if (type === 'mobile') {
                item.id = mobile.replace(/[()\s-]/g, '');
                item.country = country;
                item.type = 'mobile';
            } else if (type === 'username') {
                item.id = username;
                item.type = 'username';
            }

            const message = {
                type: 'rest',
                path: 'shortener-forgot',
                action: 'put',
                data: item
            };
            restCall(message);
        }
    }

    const ButtonNext = () => {
        if ((type === 'email' && !email) || (type === 'mobile' && !mobile) || (type === 'username' && !username)) {
            toast({message: locale.login.f, color: 'danger', display: 'bottom', duration: 3000});
        } else {
            const item = {
                account: account.current
            }
            if (type === 'email') {
                item.id = email;
                item.type = 'email';
            } else if (type === 'mobile') {
                item.id = mobile.replace(/[()\s-]/g, '');
                item.country = country;
                item.type = 'mobile';
            } else if (type === 'username') {
                item.id = username;
                item.type = 'username';
            }

            const message = {
                type: 'rest',
                path: 'user',
                action: 'get',
                data: item
            };
            restCall(message);
        }
    }

    const ButtonHelp = () => {
        Dialog({view: 'loginHelp'});
    }

    const SegmentedType = data => {
        setType(data.target.value);
        window.localStorage.login = data.target.value;
    }

    const SelectCountry = data => {
        window.localStorage.country = data;
        setCountry(data);
    }

    const ButtonSmartDocFitness = () => {
        window.location.href = 'https://smartdocfitness.com';
    }

    const UpdateShortenerForgot = useCallback(data => {
        if (data.token) {
            window.localStorage.token = data.token;
            token.current = data.token;
        }
        if (data.url) {
            wss.current = data.url;
            Navigation({view: 'dashboard'});
        }
        if (data.error && data.user) {
            toast({message: locale.login.x, color: 'danger', display: 'bottom', duration: 3000});
        }
        if (data.error && data.account) {
            toast({message: locale.login.w, color: 'danger', display: 'bottom', duration: 3000});
        }
        if (data.error && data.expired) {
            toast({message: locale.login.o, color: 'danger', display: 'bottom', duration: 3000});
        }
        setForgot(null);
    }, [Navigation, locale.login.x, locale.login.w, locale.login.o]);

    const PutShortenerForgot = useCallback(data => {
        if (data.error && data.user) {
            toast({message: locale.login.k, color: 'danger', display: 'bottom', duration: 3000});
        }
        if (data.error && data.account) {
            toast({message: locale.login.l, color: 'danger', display: 'bottom', duration: 3000});
        }
        if (data.error && data.type) {
            toast({message: locale.login.q, color: 'danger', display: 'bottom', duration: 3000});
        }
        if (data.toast) {
            toast({message: locale.login.r, color: 'info', display: 'bottom', duration: 3000});
        }
    }, [locale.login.k, locale.login.l, locale.login.q, locale.login.r]);

    const GetToken = useCallback(data => {
        if (data.token) {
            window.localStorage.token = data.token;
            token.current = data.token;
        }
        if (data.url) {
            wss.current = data.url;
            Navigation({view: 'dashboard'});
        }
        if (data.error && data.user) {
            toast({message: locale.login.k, color: 'danger', display: 'bottom', duration: 3000});
        }
        if (data.error && data.password) {
            toast({message: locale.login.n, color: 'danger', display: 'bottom', duration: 3000});
        }
    }, [locale.login.k, locale.login.n, locale.login.i, Navigation]);

    const GetUser = useCallback(data => {
        if (data.toast) {
            setNext(false);
        }
        if (data.error && data.user) {
            toast({message: locale.login.k, color: 'danger', display: 'bottom', duration: 3000});
        }
    }, [locale.login.k]);

    useEffect(() => {
        if (restResponse && !Empty(restResponse) && restResponse.action === 'update' && restResponse.path === 'shortener-forgot') {
            UpdateShortenerForgot(restResponse.data);
            setRestResponse({});
        }
    }, [restResponse, UpdateShortenerForgot, setRestResponse])

    useEffect(() => {
        if (restResponse && !Empty(restResponse) && restResponse.action === 'put' && restResponse.path === 'shortener-forgot') {
            PutShortenerForgot(restResponse.data);
            setRestResponse({});
        }
    }, [restResponse, PutShortenerForgot, setRestResponse])

    useEffect(() => {
        if (restResponse && !Empty(restResponse) && restResponse.action === 'get' && restResponse.path === 'token') {
            GetToken(restResponse.data);
            setRestResponse({});
        }
    }, [restResponse, GetToken, setRestResponse])

    useEffect(() => {
        if (restResponse && !Empty(restResponse) && restResponse.action === 'get' && restResponse.path === 'user') {
            GetUser(restResponse.data);
            setRestResponse({});
        }
    }, [restResponse, GetUser, setRestResponse])

    useEffect(() => {
        if (forgot) {
            ShortenerForgot();
        }
    }, []);

    return (
        <>
            <div className="mbsc-grid cs-login-main">
                {!Empty(configuration) &&
                    <div className="mbsc-row mbsc-justify-content-center">
                        <div className="mbsc-col-sm-9 mbsc-col-md-7 mbsc-col-xl-5 cs-login-card">
                            <div style={{backgroundImage: `url(${configuration.logo})`}} className="cs-login-card-logo" />
                            <div className={(!next && type === 'mobile') ? 'cs-login-header-mobile' : ''}>
                                {next &&
                                    <h2 className="cs-login-card-title mbsc-txt-muted">
                                        {locale.login.c}
                                    </h2>
                                }
                                {!next && type === 'mobile' &&
                                    <h2 className="cs-login-card-title mbsc-txt-muted">
                                        {mobile}
                                    </h2>
                                }
                                {!next && type === 'email' &&
                                    <h2 className="cs-login-card-title mbsc-txt-muted">
                                        {email}
                                    </h2>
                                }
                                {!next && type === 'username' &&
                                    <h2 className="cs-login-card-title mbsc-txt-muted">
                                        {username}
                                    </h2>
                                }
                            </div>
                            <div className="mbsc-row">
                                <SegmentedGroup className="cs-login-nav" name="login" color="primary" value={type} onChange={SegmentedType}>
                                    <Segmented value="email" >
                                        {locale.login.a}
                                    </Segmented>
                                    <Segmented value="mobile" >
                                        {locale.login.u}
                                    </Segmented>
                                    <Segmented value="username" >
                                        {locale.login.v}
                                    </Segmented>
                                </SegmentedGroup>
                            </div>
                            {next && type === 'mobile' &&
                                <div className="mbsc-row">
                                    <div className="mbsc-col-4 cs-login-inputs-left">
                                        <Select
                                            animation="slide-down"
                                            dropdown={false}
                                            inputStyle="outline"
                                            label={locale.login.t}
                                            labelStyle="floating"
                                            rows={locale.login.s.length}
                                            display="anchored"
                                            touchUi={false}
                                            value={country}
                                            data={locale.login.s}
                                            disabled={mobile.length !== 0}
                                            onChange={args => SelectCountry(args.value)}
                                        />
                                    </div>
                                    <div className="mbsc-col-8 cs-login-inputs-right">
                                        <Input className="cs-login-inputs-right-input" label={locale.login.u} inputStyle="outline" labelStyle="floating" type="text" name="mobile" value={mobile} onChange={ev => Mobile({data: ev.target.value, setMobile: setMobile, country: country})} />
                                    </div>
                                </div>
                            }
                            {next && type === 'email' &&
                                <Input inputStyle="outline" label={locale.login.a} labelStyle="floating" type="email" name="Email" value={email} onChange={ev => setEmail(ev.target.value)} />
                            }
                            {next && type === 'username' &&
                                <Input inputStyle="outline" label={locale.login.v} labelStyle="floating" type="text" name="Username" value={username} onChange={ev => setUsername(ev.target.value)} />
                            }
                            {!next &&
                                <Input inputStyle="outline" label={locale.login.b} labelStyle="floating" minLength="8" type="password" name="Password" passwordToggle={true} value={password} onChange={ev => setPassword(ev.target.value)} />
                            }
                            {next &&
                                <div className="mbsc-row mbsc-justify-content-end">
                                    <div className="mbsc-col-4 mbsc-button-group-block">
                                        <Button color="primary" variant="flat" className="cs-login-button mbsc-bold" onClick={() => ButtonNext()} >
                                            {locale.login.p}
                                        </Button>
                                    </div>
                                </div>
                            }
                            {!next &&
                                <div className="mbsc-row mbsc-justify-content-end">
                                    <div className="mbsc-col-4 mbsc-button-group-block">
                                        <Button color="primary" variant="flat" className="cs-login-button mbsc-bold" onClick={() => ButtonLogin()} >
                                            {locale.login.c}
                                        </Button>
                                    </div>
                                </div>
                            }
                            <div className="mbsc-row cs-login-footer-section">
                                <div className="mbsc-col cs-login-footer">
                                    <Button className="cs-login-button-lang mbsc-bold" onClick={() => ButtonHelp()} variant="flat" >
                                        {locale.login.g}
                                    </Button>
                                </div>
                                <div className="mbsc-col cs-login-footer mbsc-align-right">
                                    <Button disabled={type === 'username'} className="cs-login-button-lang mbsc-bold" onClick={() => ButtonForgot()} variant="flat" >
                                        {locale.login.e}
                                    </Button>
                                </div>
                            </div>
                            <div className="mbsc-row cs-login-footer-below">
                                <div className="mbsc-col cs-login-footer mbsc-align-center">
                                    <Button onMouseEnter={() => setIconHover('watch')} onMouseLeave={() => setIconHover(null)} className="cs-login-button-muted mbsc-bold" onClick={() => ButtonSmartDocFitness()} variant="flat" >
                                        <FontAwesomeIcon beatFade={iconHover === 'watch'} className="cs-login-icon-muted" icon={faWatchFitness} /> {locale.login.m}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {dialog.view === 'loginHelp' &&
                    <LoginHelp
                        locale={locale}
                        dialog={dialog}
                        Dialog={Dialog}
                        account={account.current}
                        width={width}
                    />
                }
            </div>
        </>
    );
}

export default Login;
